enum Theme {
	dark = "dark",
	light = "light",
}

export default Theme;
